<template>
	<div>
		<!-- 返回列表页面 -->
		<div class="jump-btn">
			<el-button type="primary" @click="backToTriningVideo()">{{$t('lang.btn_backToTriningVideo')}}</el-button>
		</div>
		<el-card class="box-card setting" shadow="always">
			<div slot="" class="clearfix">
				<span>{{$t('lang.lab_videoTypeName')}}</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="add()">{{$t('lang.btn_addFirstType')}}</el-button>
			</div>
			<div class="block">
				<el-tree :data="videoType" node-key="videoType.id" accordion default-expand-all :expand-on-click-node="false">
					<!-- default-expand-all默认全部展开  :expand-on-click-node="false"只能点图标才能展开 -->
					<span class="custom-tree-node" slot-scope="{ data }">
						<!-- v-for='(item,index) in maintaintype' :key="index" -->
						<span>{{ data.Name }}</span>
						<span>
							<!--增加分类-->
							<i @click="() => add(data)" class="el-icon-plus" v-if="data.Type==1||data.Type==2"></i>&nbsp;
							<!--删除分类-->
							<el-popconfirm :confirmButtonText="$t('lang.btn_confirm')" :cancelButtonText="$t('lang.btn_cancel')" icon="el-icon-info"
								iconColor="red" :title="$t('lang.lab_videoRemindTitle')" @onConfirm=" del(data)">
								<i v-if="data.id !== 0" class="el-icon-delete" slot="reference"></i>
							</el-popconfirm>&nbsp;
							<!--重命名分类-->
							<i v-if="data.id !== 0" @click="() => edit(data)" class="el-icon-edit-outline"></i>
						</span>
					</span>
				</el-tree>
			</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				videoType: []
			}
		},
		mounted() {
			this.getVideoTypeList()
		},
		methods: {
			// 返回
			backToTriningVideo(){
				this.$router.push({
					name: 'trainingVideoList'
				})
			},
			/* 查询视频类型列表 */
			getVideoTypeList() {
				let loading = this.$loading()
				this.$postJson('trainingVideoType/select', {})
					.then(response => {
						this.videoType = response.list
						loading.close()
					})
					.catch(error => {
						this.$message.error(error)
						loading.close()
					})
			},
			/* 新增 */
			add(data) {
				this.$prompt('', this.$i18n.t('lang.lab_addVideoType'), {
					confirmButtonText: this.$i18n.t('lang.btn_confirm'),
					cancelButtonText: this.$i18n.t('lang.btn_cancel'),
					inputValidator: (value) => { // 点击按钮时，对文本框里面的值进行验证
						if (!value) {
							return this.$i18n.t('lang.lab_videoValidator')
						}
					}

				}).then(({
					value
				}) => {
					let loading = this.$loading()
					var params = {}
					if (data == null || data == '' || data == undefined) {
						params = {
							pid: 0,
							type: 1,
							name: value,
							createPeople: this.$store.getters.staffId,
							operPeople: this.$store.getters.staffId
						}
					} else {
						params = {
							pid: data.Id,
							type: (data.Type) + 1,
							name: value,
							createPeople: this.$store.getters.staffId,
							operPeople: this.$store.getters.staffId
						}
					}
					this.$postJson('/trainingVideoType/add', params)
						.then(response => {
								this.$message.success(this.$i18n.t('lang.lab_add_success'))
								// this.partialRefresh(data)
								loading.close()
								this.getVideoTypeList()
							},
							error => {
								loading.close()
								this.$message.error(error.message)
							})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: this.$i18n.t('lang.lab_addCancelVideo')
					})
				})
			},
			/* 编辑 */
			edit(data) {
				this.$prompt('', this.$i18n.t('lang.lab_editVideoType'), {
					confirmButtonText: this.$i18n.t('lang.btn_confirm'),
					cancelButtonText: this.$i18n.t('lang.btn_cancel'),
					inputValidator: (value) => { // 点击按钮时，对文本框里面的值进行验证
						if (!value) {
							return this.$i18n.t('lang.lab_videoValidator')
						}
					}

				}).then(({
					value
				}) => {
					let loading = this.$loading()
					this.$postJson('/trainingVideoType/update', {
							id: data.Id,
							name: value,
							operPeople: this.$store.getters.staffId
						})
						.then(response => {
								this.$message.success(this.$i18n.t('lang.lab_modify_success'))
								loading.close()
								this.getVideoTypeList()
							},
							error => {
								loading.close()
								this.$message.error(error.message)
							})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: this.$i18n.t('lang.lab_editCancelVideo')
					})
				})
			},
			/* 删除 */
			del(data) {
				var loading = this.$loading()
				/* 不允许有子分类 */
				if (data.children != undefined && data.children != null && data.children[0] != undefined && data.children[0] !=
					null) {
					this.$notify({
						title: this.$i18n.t('lang.lab_prompt'),
						message: this.$i18n.t('lang.lab_delVideoMessage1'),
						type: 'warning'
					})
					loading.close()
				} else {
					// let loading = this.$loading()
					var videoType = data.Id
					/* 不允许分类下存在视频 */
					this.$get(
						`/trainingVideo/?pageNo=1&pageSize=999&type=${videoType}`
					).then(
						res => {
							var videoArr = res.list.rows
							if (videoArr.length != 0) {
								this.$notify({
									title: this.$i18n.t('lang.lab_prompt'),
									message: this.$i18n.t('lang.lab_delVideoMessage2'),
									type: 'warning'
								})
								loading.close()
							} else {
								this.$postJson('/trainingVideoType/del', {
										id: data.Id
									})
									.then(response => {
											this.$message.success(this.$i18n.t('lang.lab_del_success'))
											loading.close()
											this.getVideoTypeList()
										},
										error => {
											loading.close()
											this.$message.error(error.message)
										})
							}
						},
						error => {
							this.$message.error(error)
						}
					)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}
		.box-card >.el-card__header  {	
			padding: 10px;
			border: none !important;
			border-bottom: 0;
		}

	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.clearfix:after {
		clear: both
	}

	.box-card {
		margin: 0 auto;

		width: 680px;
	}

	.setting {
		padding: 10px;
		border-radius: 6px;
		background-color: #fff;

		.clearfix {
				text-align: left;
				padding: 20px;
				border: none;
				border-bottom: 1px solid #ebeef5;
				margin-bottom: 10px;

				.el-button {
					padding: 10px 30px;
				}
			}

		.el-card__body {
			padding: 20px;
		}
	}

</style>
